<template>
  <div class="marker-default">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="43"
      viewBox="0 0 43 43"
      class="marker-default__svg"
      v-if="isCompetitor"
    >
      <g id="Calque_2" data-name="Calque 2" transform="translate(-9.5 -9.5)">
        <circle
          id="Ellipse_11"
          data-name="Ellipse 11"
          cx="21"
          cy="21"
          r="21"
          transform="translate(10 10)"
          :fill="fill"
          :stroke="stroke"
          stroke-width="1"
        />
      </g>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43.001"
      height="52.191"
      viewBox="0 0 43.001 52.191"
      class="marker-default__svg"
      v-else
    >
      <g id="shop-4" transform="translate(-49.499 1.5)">
        <path
          id="Tracé_626"
          data-name="Tracé 626"
          d="M71,50.09,52.445,37.72A5.375,5.375,0,0,1,50,33.11V4.444A5.45,5.45,0,0,1,55.444-1h31.11A5.45,5.45,0,0,1,92,4.444V33.11a5.933,5.933,0,0,1-2.375,4.56l-.034.027Z"
          :fill="fill"
          :stroke="stroke"
          stroke-width="1"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import { generateColors } from '@/utils/colors.util'

export default {
  name: 'MarkerDefault',
  props: {
    currentValue: {
      type: [Number, String],
      required: true,
    },
    isCompetitor: {
      type: Boolean,
      required: false,
      default: false,
    },
    filters: {
      type: Array,
      required: true,
    },
    filteredByKey: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    fill() {
      if (this.filteredByKey) {
        return this.filters.find(filter => filter.key === this.currentValue)?.color || ''
      }
      return generateColors(this.currentValue, this.filters)
    },
    stroke() {
      return generateColors(this.currentValue, this.filters, true)
    },
  },
}
</script>

<style lang="scss" scoped>
.marker-default {
  display: inline-flex;

  &__svg {
    width: 100%;
    height: 100%;
  }
}
</style>
